import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

import {
  GoogleCallback,
  GoogleAuthCallback,
  OutlookCallback,
  TerraCallback,
  TodoistAuthCallback,
  TrelloAuthCallback,
  TickTickAuthCallback,
  ClickUpAuthCallback,
  CalendlyCallback,
  GithubAuthCallback,
  AppleAuthCallback,
  NotionAuthCallback,
  GoogleTasksAuthCallback,
} from '../pages';

export const CallbackRoutes: FC = () => {
  return (
    <Routes>
      <Route path={'todoist'} element={<TodoistAuthCallback />} />
      <Route path={'trello'} element={<TrelloAuthCallback />} />
      <Route path={'ticktick'} element={<TickTickAuthCallback />} />
      <Route path={'clickup'} element={<ClickUpAuthCallback />} />
      <Route path={'github'} element={<GithubAuthCallback />} />
      <Route path={'notion'} element={<NotionAuthCallback />} />
      <Route path={'google-tasks'} element={<GoogleTasksAuthCallback />} />
      <Route path={'google'} element={<GoogleCallback />} />
      <Route path={'google-auth'} element={<GoogleAuthCallback />} />
      <Route path={'outlook'} element={<OutlookCallback />} />
      <Route path={'terra'} element={<TerraCallback />} />
      <Route path={'calendly'} element={<CalendlyCallback />} />
      <Route path={'apple-auth'} element={<AppleAuthCallback />} />
    </Routes>
  );
};
